export class Sorting {
  column: string;
  direction: string;
}
